import { Link } from 'react-router-dom';
import { TbPlugConnected } from 'react-icons/tb';
import styles from './SegmentCard.module.css';

/**
 * SegmentCard — card para a seção "Para quem é".
 *
 * @param {React.ComponentType} Icon - Ícone SVG (react-icons) do segmento.
 * @param {string} title - Nome do segmento.
 * @param {string} pain - Frase de dor/benefício.
 * @param {string} [href] - Destino. Sem href, renderiza um card estático
 *   (sem navegação) — usado quando ainda não há página dedicada.
 * @param {string} [badge] - Selo opcional (ex.: "Integra com NextFit").
 *
 * Hover e focus-visible tratados via CSS (acessível por teclado).
 */
const SegmentCard = ({ Icon, title, pain, href, badge }) => {
  const inner = (
    <>
      {badge && (
        <span className={styles.badge}>
          <TbPlugConnected className={styles.badgeIcon} aria-hidden="true" />
          {badge}
        </span>
      )}
      <span className={styles.cardIcon} aria-hidden="true">
        {Icon ? <Icon /> : null}
      </span>
      <h3 className={styles.cardTitle}>{title}</h3>
      <p className={styles.cardPain}>{pain}</p>
    </>
  );

  if (!href) {
    return <div className={`${styles.card} ${styles.cardStatic}`}>{inner}</div>;
  }

  return (
    <Link to={href} className={styles.card}>
      {inner}
    </Link>
  );
};

export default SegmentCard;
